{
  "UnifiedNavigation": "在 Experience Cloud 中导航",
  "adobeExperienceCloudNoOrgsSelect": "选择其他组织帐户",
  "help": "帮助",
  "profile": "个人资料",
  "searchButton": "搜索",
  "sidenavMenuCloseTooltip": "关闭菜单",
  "sidenavMenuOpenTooltip": "打开菜单",
  "solutionSwitcher": "切换至其他解决方案",
  "toggleSideNav": "切换侧面导航菜单"
}
